<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="120px"
        v-loading="loading">
        <el-row :span="24">

          <el-col :span="24">
            <el-form-item prop="materialsName" label="供应商名称">
              <el-input clearable v-model="formData.materialsName" placeholder="请输入供应商名称" />

            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="materialsDz" label="供应商地址">
              <el-input   v-model="formData.materialsDz" placeholder="请输入供应商地址" />

            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="contactNumber" label="联系方式">
              <el-input clearable v-model="formData.contactNumber" placeholder="请输入联系方式" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList" :maxSize="50"></file-upload>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
// import { validPhoneNumber } from '@/utils/validator'
// ,
//           {
//             validator: (rule, value, callback) => {
//               if (!validPhoneNumber.test(value)) {
//                 callback(new Error('请输入有效的手机号'))
//               } else {
//                 callback()
//               }
//             },
//             trigger: ['blur', 'change']
//           }
export default {
  name: 'rawMaterialSupplierAdd',

  data () {
    return {
      formData: {

        materialsName: '',
        materialsDz: '',
        contactNumber: '',
        fileList: []
      },

      rules: {

        materialsName: [
          {
            required: true,
            message: '请输入供应商名称',
            trigger: ['blur', 'change']
          }
        ],
        materialsDz: [
          {
            required: true,
            message: '请输入供应商地址',
            trigger: ['blur', 'change']
          }
        ],
        contactNumber: [
          {
            required: true,
            message: '请输入联系方式',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false

    }
  },
  created () {
    if (this.materialsId) {
      this.loadData()
    }
  },
  computed: {
    materialsId () {
      return this.$route.query.materialsId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByMaterialsId, {
          params: { materialsId: this.materialsId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.rawMaterialSupplier.insertPaRawMaterials
          if (this.materialsId) {
            url = this.$apis.rawMaterialSupplier.updatePaRawMaterials
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

</style>
